<template>
  <div class="bestPlaces-container" @mouseleave="$emit('customMouseLeave')">
    <h2>افضل الواجهات</h2>
    <b-row class="places-list">
      <b-col sm="4" v-for="(placeName, index) in bestPlaceNames" :key="index+'s'" class="single-place-container">
        <ul>
            <li @click="onClickButton(placeName)">{{placeName}}</li>
        </ul>
      </b-col>
    </b-row>
  </div>
</template>
<script type="text/javascript">
  export default {
    name:'BestPlacesSlideDown',
    data() {
      return {
        bestPlaceNames: [
          'بالي',
          'بالي',
          'بالي',
          'بالي',
          'بالي',
          'بالي'
        ]
      }
    },
    methods: {
      onClickButton (value) {
        this.$emit('placeClicked', value);
        this.$emit('customMouseLeave');
      },

    }
  }
</script>
